<!--
  厂区总览
-->
<template>
  <div class="overview">
    <LeftSection v-show="leftAndRightShow" />
    <RightSection v-show="leftAndRightShow" />

    <!-- 缩放图标 -->
    <img
      class="scale_btn"
      :style="{ transform: `scale(${scaleBtnStyle})` }"
      src="@/assets/img/home_scale.png"
      @click="scaleSection"
    />
  </div>
</template>

<script>
// @ is an alias to /src
import LeftSection from "./components/leftSection/index.vue";
import RightSection from "./components/rightSection/index.vue";
export default {
  name: "Overview",
  components: {
    LeftSection,
    RightSection,
  },
  data(){
    return{
      scaleBtnStyle: 1,
    }
  },
  computed: {
    // 监听vuex 控制左右板块是否显示
    leftAndRightShow() {
      return this.$store.state.bothEndsShow;
    },
  },
  methods:{
    // 缩放左右板块
    scaleSection() {
      this.scaleBtnStyle = -this.scaleBtnStyle;
      // 掉用vuex中的方法修改左右板块的展示状态
      this.$store.commit("setBothEndsShow");
    },
  }
};
</script>
<style lang="less" scoped>
.overview {
  // 按钮图片
  .scale_btn{
    cursor: pointer;
    position: fixed;
    z-index: 1;
    width: 75px;
    left: 60px;
    top: 144vh * @vh;
  }
}
</style>
